export default "__VITE_ASSET__b775de22__"